module.exports = __webpack_public_path__ + "img/11.c8845dbe.png";